import { AlertsReportModel } from "../models/alerts-report";
import { AlertsReportView } from "./alerts-report";
import { backboneViewProperties } from "../../decorators/backbone-properties";

@backboneViewProperties({
    tagName: "table",
    className: "alerts-report-list",
    childView: AlertsReportView
})

export class AlertsReportListView extends Marionette.CollectionView<AlertsReportModel, AlertsReportView> {
    constructor(options?) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/my-justis/views/alerts-report-list.ts